import { faXmark } from "@fortawesome/pro-regular-svg-icons";

import { FileTypeTile } from "src/base-components/FileTypeTile";
import { IconButton } from "src/design-system/Icon";
import { humanReadableSize } from "src/utils/files";

type Props = {
  name: string;
  sizeBytes?: number;
  contentType?: string | null;
  isUploading?: boolean;
  onRemove?: () => void;
  dataLoc?: string;
};

/** A file staged in the chat composer: tinted type tile, name, size, remove. */
export const ChatFileChip: React.FC<Props> = ({
  name,
  sizeBytes,
  contentType,
  isUploading = false,
  onRemove,
  dataLoc,
}) => (
  <span
    className="inline-flex h-8 max-w-full items-center gap-1.5 rounded-lg border border-gray-200 bg-white px-1.5"
    data-loc={dataLoc}
  >
    <FileTypeTile
      contentType={contentType}
      isUploading={isUploading}
      size="sm"
    />
    <span className="min-w-0 truncate font-inter-medium-12px text-gray-800">
      {name}
    </span>
    <span className="whitespace-nowrap font-inter-normal-12px text-gray-400">
      {isUploading
        ? "Uploading..."
        : sizeBytes !== undefined && humanReadableSize(sizeBytes)}
    </span>
    {onRemove && (
      <IconButton
        aria-label="Remove attachment"
        icon={faXmark}
        size="2xs"
        onClick={onRemove}
      />
    )}
  </span>
);
